import { toast } from 'react-toastify'
import { EFToastError, EFToastSuccess } from '.'

export default function useCustomToast() {
  const showSuccessToast = (message: string, id?: any) => {
    toast.success(<EFToastSuccess text={message} />, {
      toastId: id,
      closeButton: false,
      icon: false,
      className: 'custom-toast',
      bodyClassName: 'custom-toast-body',
      position: 'top-center'
    })
  }
  const showErrorToast = (message: string, id?: any) => {
    toast.success(<EFToastError text={message} />, {
      toastId: id,
      closeButton: false,
      icon: false,
      className: 'custom-toast',
      bodyClassName: 'custom-toast-body',
      position: 'top-center'
    })
  }

  return { showSuccessToast, showErrorToast }
}
